import type * as React from 'react'

import { cn } from '@jotta/utils/css'

export function Skeleton({ className, ...props }: React.ComponentProps<'div'>) {
  return (
    <div
      data-slot="skeleton"
      className={cn(
        'relative h-6 w-full overflow-hidden rounded-xl bg-surface-container',
        "before:pointer-events-none before:absolute before:inset-0 before:content-['']",
        'before:bg-gradient-to-b before:from-transparent before:via-white/60 before:to-transparent',
        'before:animate-translate-vertical',
        className,
      )}
      {...props}
    />
  )
}
